/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 15:09:29
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-28 09:46:44
 */
import ColumnTypes from '@/utils/ColumnTypes';
const orderBanner = {
	key: 'orderBanner',
	label: '排序',
	type: ColumnTypes.orderCell,
	minWidth: '110',
};
const orderJG = {
	key: 'orderJG',
	label: '排序',
	type: ColumnTypes.orderCell,
	minWidth: '110',
};
const title = {
	key: 'title',
	label: '标题',
	type: () => import('./components/tableCells/titleCell.vue'),
	minWidth: '160',
};

const banner = {
	key: 'banner',
	label: 'banner图',
	imgType: 'banner',
	type: () => import('./components/tableCells/bannerCell.vue'),
	minWidth: '160',
};
const status = {
	key: 'status',
	label: '展示状态',
	helpNum: 1,
	helpDesc1: '关闭后该素材将不在小程序选品中心中展示',
	type: () => import('./components/tableCells/statusCell.vue'),
	minWidth: '100',
};
const linkTypeDesc = {
	key: 'linkTypeDesc',
	label: '跳转类型',
	type: ColumnTypes.TextCell,
	minWidth: '180',
};
const showcaseSkip = {
	key: 'showcaseSkip',
	label: '跳转类型',
	type: () => import('./components/tableCells/showcaseSkipCell.vue'),
	minWidth: '120',
};
const skipIp = {
	key: 'skipIp',
	label: '跳转位置',
	type: () => import('./components/tableCells/skipIpCell.vue'),
	minWidth: '120',
};
const showcaseSkipIp = {
	key: 'showcaseSkipIp',
	label: '跳转位置',
	type: () => import('./components/tableCells/showcaseSkipIpCell.vue'),
	minWidth: '120',
};

const jgTitle = {
	key: 'title',
	label: '金刚位名称',
	type: ColumnTypes.TextCell,
	minWidth: '100',
};
const icon = {
	key: 'icon',
	label: 'icon 图',
	imgType: 'icon',
	type: () => import('./components/tableCells/bannerCell.vue'),
	minWidth: '160',
};
const style = {
	key: 'style',
	label: '橱窗样式',
	type: () => import('./components/tableCells/showcaseCell.vue'),
	minWidth: '160',
};
const bannerName = {
	key: 'bannerName',
	label: '集合页名称',
	type: () => import('./components/tableCells/bannerNameCell.vue'),
	minWidth: '100',
};
const bannerImg = {
	key: 'bannerImg',
	label: '集合页banner图',
	imgType: 'banner',
	type: () => import('./components/tableCells/bannerCell.vue'),
	minWidth: '160',
};
const linkCount = {
	key: 'linkCount',
	label: '关联资源位数量',
	type: ColumnTypes.TextCell,
	minWidth: '160',
};
const concactGroup = {
	key: 'concactGroup',
	label: '关联商品组',
	type: () => import('./components/tableCells/concatGroupCell.vue'),
	minWidth: '160',
};
const productNum = {
	key: 'productNum',
	label: '有效商品数量',
	type: ColumnTypes.TextCell,
	minWidth: '160',
};

const operations = {
	key: 'operations',
	label: '操作',
	type: ColumnTypes.ButtonsCell,
	minWidth: '100',
	align: 'right',
};

// banner配置
export const bannerColumns = [orderBanner, title, banner, status, linkTypeDesc, skipIp, operations];

// 金刚区配置
export const JGColumns = [orderJG, jgTitle, icon, status, linkTypeDesc, skipIp, operations];

// 橱窗配置
export const showcaseColumns = [title, style, status, showcaseSkip, showcaseSkipIp, operations];

// 集合页配置
export const collectionColumns = [bannerName, bannerImg, status, linkCount, concactGroup, productNum, operations];
